export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';
export const SET_DRAWER = 'SET_DRAWER';
